// SHADOW NETWORK · Monthly prizes section (5 cards) for /shadow/ranking.
// Rendered ABOVE the existing stats bar — additive only.
import React from "react";

const PREMIOS = [
  {
    puesto: "1°",
    emoji: "🥇",
    color: "#FFD700",
    premio: { es: "$300 USDC", en: "$300 USDC", sk: "$300 USDC", de: "$300 USDC", "zh-CN": "$300 USDC" },
    label: { es: "Primer Lugar", en: "First Place", sk: "Prvé Miesto", de: "Erster Platz", "zh-CN": "第一名" },
  },
  {
    puesto: "2°",
    emoji: "🥈",
    color: "#C0C0C0",
    premio: { es: "$200 USDC", en: "$200 USDC", sk: "$200 USDC", de: "$200 USDC", "zh-CN": "$200 USDC" },
    label: { es: "Segundo Lugar", en: "Second Place", sk: "Druhé Miesto", de: "Zweiter Platz", "zh-CN": "第二名" },
  },
  {
    puesto: "3°",
    emoji: "🥉",
    color: "#CD7F32",
    premio: { es: "$100 USDC", en: "$100 USDC", sk: "$100 USDC", de: "$100 USDC", "zh-CN": "$100 USDC" },
    label: { es: "Tercer Lugar", en: "Third Place", sk: "Tretie Miesto", de: "Dritter Platz", "zh-CN": "第三名" },
  },
  {
    puesto: "4°",
    emoji: "🛍️",
    color: "#9b59ff",
    premio: {
      es: "50% Descuento Shadow Market",
      en: "50% Off Shadow Market",
      sk: "50% Zľava Shadow Market", de: "50% Rabatt Shadow Market", "zh-CN": "Shadow Market 五折优惠",
    },
    label: { es: "Cuarto Lugar", en: "Fourth Place", sk: "Štvrté Miesto", de: "Vierter Platz", "zh-CN": "第四名" },
  },
  {
    puesto: "5°",
    emoji: "🎁",
    color: "#00d4ff",
    premio: {
      es: "25% Descuento Shadow Market",
      en: "25% Off Shadow Market",
      sk: "25% Zľava Shadow Market", de: "25% Rabatt Shadow Market", "zh-CN": "Shadow Market 75折优惠",
    },
    label: { es: "Quinto Lugar", en: "Fifth Place", sk: "Piate Miesto", de: "Fünfter Platz", "zh-CN": "第五名" },
  },
];

const TITLES = {
  es: "🏆 Premios Mensuales — Shadow Ranking™",
  en: "🏆 Monthly Prizes — Shadow Ranking™",
  sk: "🏆 Mesačné Ceny — Shadow Ranking™", de: "🏆 Monatliche Preise — Shadow Ranking™", "zh-CN": "🏆 月度奖励 — Shadow Ranking™",
};

const SUBTITLES = {
  es: "Top 5 traders con mejores análisis del mes ganan premios reales",
  en: "Top 5 traders with best monthly analyses win real prizes",
  sk: "Top 5 obchodníkov s najlepšími analýzami mesiaca vyhrávajú skutočné ceny", de: "Top 5 Trader mit den besten Analysen des Monats gewinnen echte Preise", "zh-CN": "本月分析最佳的前5名交易员将获得实物奖励",
};

export const PremiosMensuales = ({ lang = "es" }) => {
  const l = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  return (
    <section
      data-testid="premios-mensuales"
      className="rounded-2xl border border-amber-400/25 bg-gradient-to-b from-amber-500/[0.05] to-transparent p-4 md:p-6"
    >
      <header className="mb-4 text-center">
        <h2 className="text-base font-black tracking-tight text-amber-300 md:text-lg">
          {TITLES[l]}
        </h2>
        <p className="mt-1 text-xs text-white/55 md:text-sm">{SUBTITLES[l]}</p>
      </header>

      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 md:grid-cols-5">
        {PREMIOS.map((p) => (
          <div
            key={p.puesto}
            data-testid={`premio-card-${p.puesto.replace("°", "")}`}
            className="flex flex-col items-center rounded-xl border bg-black/40 px-3 py-4 text-center transition-all hover:-translate-y-0.5"
            style={{
              borderColor: `${p.color}55`,
              boxShadow: `0 0 0 0 ${p.color}00`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = `0 0 24px ${p.color}33`;
              e.currentTarget.style.borderColor = `${p.color}aa`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = `0 0 0 0 ${p.color}00`;
              e.currentTarget.style.borderColor = `${p.color}55`;
            }}
          >
            <div className="text-3xl leading-none" aria-hidden="true">
              {p.emoji}
            </div>
            <div
              className="mt-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.18em]"
              style={{ color: p.color }}
            >
              {p.puesto}
            </div>
            <div className="mt-2 text-[13px] font-black leading-tight text-amber-200 sm:text-sm">
              {p.premio[l] || p.premio.es}
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-[0.12em] text-white/45">
              {p.label[l] || p.label.es}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PremiosMensuales;
